import { FieldConfig } from "../../common/forms/Interfaces";

const config = {
  email: {
    label: "E-mail",
    validationRules: [{ required: true, message: "Please enter E-mail!" }],
    type: "email",
  },
} as { [key: string]: FieldConfig };

export default config;
